import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: { display: "flex", justifyContent: "space-between" },
  rootPreview: {
    display: "flex",
    flexDirection: "column",
    padding: "2rem",
    borderRadius: 5,
    border: `1px solid ${LIGHT_GREY}`,
  },
  rootContent: { padding: theme.spacing(2, 0) },
}));
